import apiUrl from '../../../../constants'
import axios from 'axios'

import {
  Validator
} from 'vee-validate'
import {
  BasicSelect
} from 'vue-search-select'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import utils from '../../../../utils/validateScanner.js'
import IRTException from '../../../../utils/IRTException.js'

export default {
  name: 'hub-details',
	mixins: [utils,IRTException],
  components: {
    BasicSelect,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoading: false,
      PortList: '',
      portlist: [],
      WeightDetails: [],
      portitem: {
        id: '',
        text: ''
      },
      hubid: '',
      portname: '',
      boudrate: '9600',
      weighttype: '',
      length: '',
      breadth: '',
      height: '',
      physicalweight: '',
      ShipmentID: '',
      displayShipmentid: '',
      confirmwt: false,
      confirmvolwt:false,
      Destination: '',
      ProcessCode: '',
      ZoneName: '',
      fullSuccessMessage: '',
      disabledLength: 1,
      disabledBreadth: 1,
      disabledHeight: 1,
      disabledPhysicalWeight: 1,
      ConfirmPhysicalWeight: false,
      ConfirmVolumetricWeight:false,
      IsHeavyShipment:false,
      mpsType : '',
      inscanShipmentid:'',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[],
      clientType : '',
      section:null,
      bayNo:null,
      ptlid:null,
      ServiceType: '',
      priorityflag:null,
      centerType:null,
      facilitytype:null,
      MOT:'',
      ShipmentType:'',
      shipmentModal:false,
			viewList:false,
			createBag:false,
			delinkShipment:false,
			confirmDelink:false,
			bagShipmentID:'',
			delinkBagShipmentID:'',
			bagSeal:'',
			basketData:{},
			bagDestinationObj:{},
			ShipmentList:[],
			ShipmentCount:0,
			bagShipmentIDError:'',
			bagSealError:'',
			delinkBagShipmentIDError:'',
			bShipInScan:false,
			bSealInScan:false,
			basketLoader:true,
			preModal:'',
      IsWeighingInfraAvailable:'',
		// FM Bagging
		handovertype:'',
		handovererrors:'',
		handoverBag:'',
		showfmlist:false,
		loadingFMList:false,
		fmPendencyList:[],
		handoverBagError: '',
		isfmbagInScan: false,
		fmbagInScanObj: {},
		fmMarkingIds: {},
		checked:[],
		supervisor: false,
		intiateFMShortage:false,
		pShipmentArr:[],
		showAdherenceModal:false,
		adherenceMsg:'',
		adherenceType:'',
		bagConfirmData:{}
    }
  },
  computed: {},
    mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
	this.useremail = userdetail[0].email;
    this.userid = parseInt(userdetail[0].userid, 10);
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.hubid = userdetail[0].HubId[0];
    this.getPortList()
    this.getHubDetails(this.hubid)
     .then(centerType => {
       this.centerType = centerType;
     })
	// Get List of IRT Exception Type
    this.getExceptionTypes();
  },
  watch: {
 centerType(newValue) {
   this.facilitytype=newValue;
 }
},
  methods: {

    selectPort(portitem) {
      this.portitem = portitem
      this.portitem.text = this.portname
    },
    getPortList() {
      if (process.env.NODE_ENV !='production') {
        this.disabledLength = this.disabledBreadth = this.disabledHeight = this.disabledPhysicalWeight = 0;
        this.portlist = [{
          comName:'COM3'
        }];
      } else {
        axios({
          method: 'GET',
          'url': 'http://localhost:8081/api/portlist'
        })
        .then(result => {
          // var comArr = [{"comName":"/dev/ttyS0"},{"comName":"/dev/ttyS1"},{"comName":"/dev/ttyS10"},{"comName":"/dev/ttyS11"},{"comName":"/dev/ttyS12"},{"comName":"/dev/ttyS13"},{"comName":"/dev/ttyS14"},{"comName":"/dev/ttyS15"},{"comName":"/dev/ttyS16"},{"comName":"/dev/ttyS17"},{"comName":"/dev/ttyS18"},{"comName":"/dev/ttyS19"},{"comName":"/dev/ttyS2"},{"comName":"/dev/ttyS20"},{"comName":"/dev/ttyS21"},{"comName":"/dev/ttyS22"},{"comName":"/dev/ttyS23"},{"comName":"/dev/ttyS24"},{"comName":"/dev/ttyS25"},{"comName":"/dev/ttyS26"},{"comName":"/dev/ttyS27"},{"comName":"/dev/ttyS28"},{"comName":"/dev/ttyS29"},{"comName":"/dev/ttyS3"},{"comName":"/dev/ttyS30"},{"comName":"/dev/ttyS31"},{"comName":"/dev/ttyS4"},{"comName":"/dev/ttyS5"},{"comName":"/dev/ttyS6"},{"comName":"/dev/ttyS7"},{"comName":"/dev/ttyS8"},{"comName":"/dev/ttyS9"},{"comName":"/dev/ttyUSB0","manufacturer":"FTDI","serialNumber":"FTDI_Chipi-X_FT0DI38A","pnpId":"usb-FTDI_Chipi-X_FT0DI38A-if00-port0","vendorId":"0x0403","productId":"0x6015"}];

          var comArr = result.data;
          this.portlist = comArr.filter(res => {
            let manufacturer='';
            if(res.manufacturer)
            {
              manufacturer=res.manufacturer.toLowerCase();
            }
            if(res.manufacturer == 'FTDI' || res.manufacturer == 'Megawin_Technology_Co.__Ltd.' || manufacturer.includes('prolific') || manufacturer.includes('cadyce')){
              return res.manufacturer
            }
          })

          // var portlst = '';
          // var result2 = {
          //   "returnCode": "100",
          //   "returnMessage": "successful",
          //   "comName": "/dev/ttyUSB0"
          // }
          // var result1 = [result]
          // for (var i = 0; i < result1.length; i++) {
          //   portlst = result1[i].comName.match(/\//);
          // }
          // this.PortList = result1.comName;
          // console.log(portlst.input);
          // this.PortList = [{
          //   'portname': portlst.input
          // }]
          //    if (result.data.returnCode == 100) {
          // this.PortList = result.data.comName;
          //    } else {
          //  this.$alertify.error(result.data.returnMessage)
          //    }
        }, error => {
          console.error(error)
          if (error.response == undefined) {
            this.$alertify.error('DWS machine not connected')
          }
        })
      }
    },
    calculateWeight(pickupExists) {
      if (process.env.NODE_ENV !='production') {
        this.inscan(pickupExists);
      } else {
        //  debugger
        this.input = ({
          "baudrate": this.boudrate,
          "port": this.portlist[0].comName,
          "machinetype": "R"
        })
        axios({
          method: 'POST',
          'url': 'http://localhost:8081/api/calWeight',
          'data': this.input

        })
        .then(result => {
          //  if (result.data.returnCode == 100) {
          this.WeightDetails = result.data.weight;
          var str = this.WeightDetails
          // var str = "W000416L096B128H076"

          var strWt = str.indexOf("W") > -1 && str.indexOf("L") > -1 ? str.slice(str.indexOf("W"), str.indexOf("L")).substr(1) : 0
          this.physicalweight = strWt / 1000
          var strLn = str.indexOf("L") > -1 && str.indexOf("B") > -1 ? str.slice(str.indexOf("L"), str.indexOf("B")).substr(1) : 0
          this.length = strLn / 10
          var strBt = str.indexOf("B") > -1 && str.indexOf("H") > -1 ? str.slice(str.indexOf("B"), str.indexOf("H")).substr(1) : 0
          this.breadth = strBt / 10
          var strHt = str.indexOf("H") > -1 ? str.slice(str.indexOf("H")).substr(1) : 0
          this.height = strHt / 10
          this.inscan(pickupExists);
          //  }
        }, error => {
          if (error.response == undefined) {
            this.$alertify.error('DWS machine not connected')
          }
          console.error(error)
        })
      }
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    inscan(pickupExists) {

      if (this.length > 250 || this.breadth > 250 || this.height > 250) {
        (this.length > 250) ? this.$alertify.error("The Length field must be 250 or less.") : (this.breadth > 250) ? this.$alertify.error("The Breadth field must be 250 or less.") : (this.height > 250) ? this.$alertify.error("The Height field must be 250 or less.") : '';
        return false;
      }
      if (this.physicalweight <= 0) {
        this.$alertify.error("Physical weight cannot be blank or zero")
        return false;
      }
      if (this.physicalweight > 20) {
        this.confirmwt = true
        this.ConfirmPhysicalWeight = true
        this.$alertify.error("Physical Weight is more than 20 KG")
      } else {
        this.confirmwt = false
      }
      this.VolumetricWeight = (this.length * this.breadth * this.height) / 6000;
      if (this.VolumetricWeight > 20) {
        this.confirmvolwt = true
        this.ConfirmVolumetricWeight = true
        this.$alertify.error("Volumetric Weight is more than 20 KG")
      } else {
        this.confirmvolwt = false
      }
      this.input = ({
        "shippingID": this.ShipmentID,
        "originHubID": this.hubid,
        "lastModifiedBy": this.createdBy,
        "physicalWeight": this.physicalweight,
        "shipmentLength": this.length,
        "shipmentBreadth": this.breadth,
        "shipmentHeight": this.height,
        "inScanFromDevice": this.weighttype,
        "isConfirmInScan": true,
        "isConfirmVolWt": this.ConfirmVolumetricWeight,
        "isConfirmPhyWt": this.ConfirmPhysicalWeight,
        "latitude": null,
		"longitude": null,
        "deviceID": null,
        "deviceCapturedDate": null,
        "statusMarkedFrom": "WEB",
        "shipmentImageUrl": "",
        "inscanType": 3,
        "isManualEntry": this.manualInput,
        "facilitytype":this.facilitytype
      })

      if (this.userid) {
        this.input.userId = this.userid;
      }
      if (pickupExists) {
        this.input.isPickUpBasketFacility = true;
      }

	  	// FM Bagging
		if(this.restrictionConfig && this.restrictionConfig.isFmBaggingLoc && this.handoverBag) {
			this.input.bagNumber = this.handoverBag;
		}

		if (this.isAdherenceFalse) {
			this.input.isAdherence = false;
			this.isAdherenceFalse = false;
		}

      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'manualShipmentInScan',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then((result) => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.inscanShipmentid = this.ShipmentID;
              this.ShipmentID = ''
              this.manualInput = false
              this.clientType = ''
              this.$validator.reset()
              this.$alertify.success(result.data.ReturnMessage)
              this.getHubCode()
			  this.fmBagSealInScan();
            } else if (result.data.ResultCode == 103) {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
              this.ShipmentID = '';
              this.manualInput = false
              this.fullSuccessMessage = '';
              this.Destination = '';
              this.ProcessCode = '';
              this.ZoneName = '';
              this.$validator.reset()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 208) {
              this.isLoading = false;
              this.adherenceMsg = result.data.ReturnMessage;
              this.adherenceType = 'inscan';
              this.showAdherenceModal = true;
            } else {
			  // IRT Exception Error & Tracking No
			  if(result.data.Trackingno) this.openIRTExceptionModal(this.ShipmentID, result.data.ReturnMessage, result.data.Trackingno);
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
              this.ShipmentID = '';
              this.manualInput = false
              this.fullSuccessMessage = '';
              this.Destination = '';
              this.ProcessCode = '';
              this.ZoneName = '';
              this.displayShipmentid = '';
              this.inscanShipmentid = '';
              this.$validator.reset()
            }
            user_tracker.checkUserIP(this.userData[0], "DWSinscan",this.$route.path,this.input);
          },
          error => {
            console.error(error)
          }
        )
    },
    getHubCode() {
      this.fullSuccessMessage = '';
      this.isLoading = true;
      this.MPSQuantity='';
			this.MpsGroupID='';
			this.showQuentity=false;
      this.MOT = '';
      this.ShipmentType = '';

      let pupStr = (this.restrictionConfig && this.restrictionConfig.pickupExists) ? `&isPickUpBasketFacility=true&userId=${this.userid}` : '';

      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getHubColourCode?shippingID=" + this.inscanShipmentid + pupStr,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            // PXB-7142 Shipment Color Code & Icon
						if(Object.keys(result.data.lossCategorization).length !=0){
							this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
						}

            // Multiple processing Center Connectivity
						this.pickUpBasketData = (this.pickUpBasketData) ? result.data.ResponseData.pickUpBasketData :[];

            this.invalidTokenModal = false
            this.isLoading = false;
            this.fullSuccessMessage = '1'
            this.IsHeavyShipment = result.data.isHeavyShipment
            this.mpsType = result.data.ResponseData.mpsType
            this.displayShipmentid = result.data.ResponseData.shippingId
            this.Destination = (this.pickUpBasketData) ? result.data.ResponseData.nextBagDestination : result.data.ResponseData.HubName;
            this.ProcessCode = result.data.ResponseData.ProcessCode
            this.ZoneName = result.data.ResponseData.ZoneName
            this.clientType = result.data.ResponseData.clientType;
            this.ServiceType = result.data.ResponseData.serviceType;
            this.section = result.data.ResponseData.sortersection;
            this.bayNo = result.data.ResponseData.bayno;
            this.priorityflag = result.data.ResponseData.fmPriorityFlag;
            this.MOT = result.data.ResponseData.MOT;
            this.ShipmentType = result.data.ResponseData.ShipmentType;
            this.ptlid = (this.section.includes('PTL') && result.data.ResponseData.ptlid) ? result.data.ResponseData.ptlid : ``;
            if(result.data.ResponseData.count){
							this.MPSQuantity = result.data.ResponseData.count;
							this.MpsGroupID = result.data.ResponseData.mpsGroupId;
							this.showQuentity =true
						}
            // this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.isLoading = false;
            this.fullSuccessMessage = ''
            this.Destination = ''
            this.ProcessCode = ''
            this.ZoneName = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false;
          this.$alertify.error("Error at getHubColourCode API")
          console.error(error)
        })
    },
    resetForm() {
      this.handovererrors = '';
      this.weighttype = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.physicalweight = ''
      this.IsHeavyShipment = false
      this.mpsType = ''
      this.ConfirmPhysicalWeight = false
      this.ConfirmVolumetricWeight = false
      this.confirmwt = false
      this.confirmvolwt = false
      this.displayShipmentid=''
      this.inscanShipmentid = ''
      // FM Bagging
			this.handovertype = '';
			this.handovererrors = '';
			this.handoverBag = '';
			this.showfmlist = false;
			this.loadingFMList= false;
			this.fmPendencyList= [];
			this.bagSealError= '',
			this.isfmbagInScan= false;
			this.fmbagInScanObj= {};
      this.$validator.reset()
    },
    cancelID() {
      this.portitem = {
        id: '',
        text: ''
      }
      this.portname = ''
      this.boudrate = '9600'
      this.weighttype = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.physicalweight = ''
      this.ShipmentID = ''
      this.manualInput = false
      this.confirmwt = false
      this.IsHeavyShipment = false
      this.mpsType = ''
      this.fullSuccessMessage =false
      this.ConfirmPhysicalWeight = false
      this.ConfirmVolumetricWeight = false
      this.confirmwt = false
      this.confirmvolwt = false
      this.displayShipmentid=''
      this.inscanShipmentid = '',
      this.MPSQuantity='';
			this.MpsGroupID='';
			this.showQuentity=false;
      this.centerType='';
      this.facilitytype='';
      this.$validator.reset()

      this.showHideCodeIconInput();
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },

    fetchBagShipmentList(data,type,i) {

			this.closeCreateDelinkModal();

			this.basketData = data ? data : this.basketData;
			this.basketData = Object.assign({}, this.basketData, {i:i});

			this.shipmentModal = true;
			this.basketLoader = true;
			
			if(type=='list') {	

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'pickupCenter/getShipmentCountList?pickupHubId=' + this.hubid + '&basketBarcode=' + this.basketData.basket+'&requestType=2',
					'data': {},
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {

						this.ShipmentList = result.data.ShipmentList;
						this.ShipmentCount = result.data.ShipmentCount;

						this.viewList = true;
					}else{
						this.shipmentModal = false;
						this.$alertify.error(result.data.ReturnMessage);
						return false;
					}
				}, error => {
					this.shipmentModal = false;
					console.error(error);
				})
			}
			else if(type=='delink') this.delinkShipment = true;
			else if(type=='bag') this.createBag = true;

			this.basketLoader = false;
		},

		delinkBagShipment(i) {

			if (!this.delinkBagShipmentID) {
				this.delinkBagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.delinkBagShipmentIDError = '';
			this.basketLoader = true;

			this.input = ({
				"shippingId": this.delinkBagShipmentID.toString(),
				"pickupHubId": this.hubid,
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.createdBy
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkShipment',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.delinkBagShipmentID = '';

					this.basketData = Object.assign({}, this.basketData, {count:result.data.RemainingLinkedCount});
					this.pickUpBasketData[i].count = result.data.RemainingLinkedCount;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		takeAction(i) {
			if(this.preModal=='delink') {
				// Delink All shipment
				this.delinkAllBagShipment(i);
			} else {
				// Close Bag Modal
				this.closeCreateDelinkModal();
			}
		},

		delinkAllBagShipment(i) {
			this.basketLoader = true;

			this.input = ({
				"pickupHubId": this.hubid,
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.createdBy
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkAllShipments',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.basketData = Object.assign({}, this.basketData, {count:0});
					this.pickUpBasketData[i].count = 0;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagShipment() {
			if (!this.bagShipmentID) {
				this.bagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.bagShipmentIDError = '';

			this.bShipInScan = false;
			this.basketLoader = false;

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanShipmentForBagClose?pickupHubId=' + this.hubid + '&basketBarcode=' + 
				this.basketData.basket+'&shippingId=' + this.bagShipmentID.toString()+'&createdBy=' + this.createdBy,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bShipInScan = true;
					this.bagShipmentID = '';
					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagSeal() {
			if (!this.bagSeal) {
				this.bagSealError = 'Seal Number field is required.'; return;
			}
			this.bagSealError = '';

			this.bSealInScan = false;
			this.basketLoader = true;
			this.bagDestinationObj={};

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanBagSealApi?pickupHubId='+this.hubid+'&basketBarcode='+ 
				this.basketData.basket+'&bagDestinationHubName='+this.basketData.nextbagdestination+'&bagSealNo='+this.bagSeal+'&bagType=surfacebag'+
				'&createdBy=' + this.createdBy+'&userId=' + this.userid,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bSealInScan = true;
					
					this.bagDestinationObj = {
						"bagDestinationHubId": result.data.ResponseData.destinationHubId,
						"bagDestinationHubName": result.data.ResponseData.destinationHubName,
						"groupId": result.data.ResponseData.groupId
					}

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		closeBag() {
			this.basketLoader = true;
			
			this.input = ({
				"pickupHubId": Number(this.hubid),
				"pickupHubName": this.hubname,
				"basketBarcode": this.basketData.basket,
				"bagSealNo": this.bagSeal,
				"bagDestinationHubId": this.bagDestinationObj.bagDestinationHubId,
				"bagDestinationHubName": this.bagDestinationObj.bagDestinationHubName,
				"groupId": this.bagDestinationObj.groupId,
				"bagType": 'surfacebag',
				"createdBy": this.createdBy,
				"userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/bagCloseApi',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.pickUpBasketData[this.basketData.i].count = 0;

					this.basketData = {};
					this.closeCreateDelinkModal();

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		closeCreateDelinkModal() {
			this.shipmentModal = false;
			this.viewList = false;
			this.createBag = false;
			this.delinkShipment = false;
			this.confirmDelink = false;

			this.resetBasketModule();

			this.ShipmentList = [];
			this.ShipmentCount = 0;
		},

		resetBasketModule() {
			this.bagShipmentID = '';
			this.bagShipmentIDError = '';
			this.bagSeal = '';
			this.bagSealError = '';
			this.delinkBagShipmentID = '';
			this.delinkBagShipmentIDError = '';
			this.bagDestinationObj={};
			this.bShipInScan = false;
			this.bSealInScan = false;
			this.basketLoader = false;
		},

    	// FM Bagging
		fmBagSealInScan() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			// Match role for SUpervisor
			this.supervisor = this.validateUserRole(this.roleconfig.sup_roles_fmb_shortage);
			// this.supervisor = false;

			this.handovererrors = '';
			this.handoverBagError = '';
			this.isfmbagInScan = false;

			this.isLoading = true;
			this.fmbagInScanObj={};

			this.input = ({
				"hubId": this.hubid,
				"bagSealNumber": this.handoverBag,
				"eventName": "FmBagValidate",
				"userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/hubInScanFMBag',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.isfmbagInScan = true;
					this.fmbagInScanObj = result.data.ResponseData;

					this.$alertify.success(result.data.ReturnMessage);
				}else if(result.data.ResultCode == 104){
					this.adherenceMsg = result.data.ReturnMessage;
					this.adherenceType = 'bag';
					this.bagConfirmData = result.data.ResponseData;
					this.showAdherenceModal = true;
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		},

	completeHubInScan() {
			if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.isLoading = true;

			this.input = ({
				"hubId": this.hubid,
				"userId": this.userid,
				"bagSealNumbers": this.handoverBag,
				"eventName": "CompleteHubInScan",
				"source": "WEB"
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/completeHubInScan',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		},

		confirmAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.isfmbagInScan = true;
				this.fmbagInScanObj = this.bagConfirmData;
				this.handoverBag = this.fmbagInScanObj.bagSealNumber ;
				return;
			}
			this.isAdherenceFalse = true;
			this.inscan(this.restrictionConfig && this.restrictionConfig.pickupExists ? this.restrictionConfig.pickupExists : null);
		},

		cancelAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.bagConfirmData = {};
			}
		},

		clearhandoverError(){
			if (this.handovertype) {
				this.handovererrors = '';
				this.handoverBag = '';
				this.fmbagInScanObj = {};

				this.isfmbagInScan = (this.handovertype == 'shipment') ? true : (this.handovertype == 'bag') ? false : this.isfmbagInScan;
				
			}
		},

		openFMShipmentPendencyList() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.handovererrors = '';
			this.handoverBagError = '';
			this.showfmlist = true;

			this.getFMBagPendencyInscan();
		},

		getFMBagPendencyInscan(){

			this.loadingFMList = true;
			this.fmPendencyList = [];

			this.input = ({
				"hubId": this.hubid,
				"bagSealNumber": this.handoverBag
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/getFMBagShipmentList',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					let responseData = result.data.ResponseData;
					if (responseData && responseData.shipments) {
						responseData.pendingshipments = responseData.shipments;
					}
					this.fmPendencyList = responseData;
					this.showfmlist=true;
					this.$alertify.success(result.data.ReturnMessage)
				}else{
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.loadingFMList=false;
			}, error => {
				console.error(error);
				this.loadingFMList=false;
			})
		},

		markFMShortage(data) {
			if(data) {
				this.$set(this.fmMarkingIds, data.shippingId, true);
			}

			this.loadingFMList = true;

			let payload = {
				hubId: this.hubid,
				shipmentIds: (this.pShipmentArr.length) ? this.pShipmentArr : [data.shippingId],
				bagId: this.handoverBag,
				userId: this.userid,
				createdBy: this.useremail,
				isSupervisor: this.supervisor,
				eventName: "RaiseShortageRequest"
			};

			axios.post(`${apiUrl.api_url_hubops}fmBagging/initiateORMarkFMShortage`, 
				payload, {
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
				}}
			).then(res => {
				if (res.data.ResultCode !== 100) this.$alertify.error(res.data.ReturnMessage || "Already Marked", "error");
				else {
					this.$alertify.success(res.data.ReturnMessage, "success");
					if(data) {
						data.isMarked = true;
					}
					this.getFMBagPendencyInscan();
					this.pShipmentArr = [];
				}

				this.loadingFMList = false;
				this.intiateFMShortage = false;
			}).catch(err => this.$alertify.error(err.message, "error"))
			.finally(() => {
				if(data) {
					this.$set(this.fmMarkingIds, data.shippingId, false);
				}
			});
		},

		closeFMModal() {
			this.intiateFMShortage = false;
			this.showfmlist = true;
		},

		resethandovertype(){
			this.handovertype = '',
			this.handovererrors = '',
			this.handoverBag = '',
			this.fmbagInScanObj = {};
			this.fullSuccessMessage =false;
			this.resetForm();
		},

		isfmMarked(shippingId) {
			let fmShip = this.fmPendencyList.pendingshipments.find(b => b.shippingId == shippingId);
			return fmShip && fmShip.isMarked;
		},

		updateCheckDest(event){
			this.checked[event.target.id] = event.target.checked;

			if(event.target.checked==false){
				this.pShipmentArr = this.pShipmentArr.filter(el => el != event.target.id)

			}else{
				this.pShipmentArr.indexOf(event.target.id) === -1 ? this.pShipmentArr.push(event.target.id):'';
			}
		}
  }
}



// WEBPACK FOOTER //
// ./src/views/components/HubInscan/DWSInscan/DWSInscan.component.js